import axios from 'axios';
import { createSignedGetRequest } from 'utils/createSignedRequestsHelpers';
import { PAYMENTS_LOCAL_API_REQUESTS } from './utils/constants';

/** The latest payment attempt for an invoice, refreshed from the provider. */
export const getInvoicePayment = async (
  projectId,
  invoiceId,
  activeEmployerInfo = {}
) => {
  const apiPath = `invoice/${projectId}/${invoiceId}/payment`;

  const signedRequest = await createSignedGetRequest({
    apiPath,
    activeEmployerInfo,
    isLocalApiRequest: PAYMENTS_LOCAL_API_REQUESTS,
  });

  const response = await axios(signedRequest);

  return response.data;
};
